module.exports = __webpack_public_path__ + "static/pho5-d98cb51de58e43c9a2b01c0814a684f5.jpg";